<template>
  <div
    :class="{
      'cblack': isBlack,
      'gucci-app': $root.isApp,
      'screenshot': $root.isScreenshot,
      'homepage': $route.name === 'Home'
    }"
    class="lang-switcher"
  >
    <h4 class="current-lang regular uppercase">{{ $route.params.language }}</h4>
    <arrowDown class="arrow" />
    <div class="other-lang">
      <h4
        @click="switchCurrentLang(lang)"
        v-for="lang in availableLanguages"
        :key="lang"
        class="regular uppercase"
      >
        {{ lang }}
      </h4>
    </div>
  </div>
</template>

<script>
import arrowDown from '@/assets/svg/arrow-down.svg'

export default {
  components: {
    arrowDown
  },

  props: {
    isBlack: {
      type: Boolean,
      default: false
    }
  },

  mounted () {
    if (this.$root.isApp) {
      this.isApp = true
    }
  },
  data () {
    return {
      isApp: false
    }
  },
  computed: {
    availableLanguages () {
      const allLang = []
      for (const lang in this.$root.allLanguages) {
        const element = this.$root.allLanguages[lang]
        if (element._slug !== this.$route.params.language) {
          allLang.push(element._slug)
        }
      }
      return allLang
    }
  },
  methods: {
    switchCurrentLang (currentLang) {
      this.$events.$emit('change-language', currentLang)
      this.$router.push({ params: { language: currentLang } })
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'generic_event',
          eventCategory: 'Clicks on Language',
          eventAction: currentLang,
          eventLabel: ''
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.lang-switcher {
  cursor: pointer;
  display: inline-block;
  pointer-events: auto;
  position: fixed;
  top: 36px;
  right: 48px;
  transition: all 0.3s ease-in-out;

  @include breakpoint('sm-and-down') {
    top: 24px;
    right: 12px;
  }

  &.gucci-app {
    top: 80px;
  }

  &.screenshot {
    top: 76px;
  }

  &:hover {
    .current-lang {
      color: $c-pink;
    }

    .other-lang {
      height: auto;
    }

    .arrow {
      transform: scale(1.3) rotate(180deg);

      path {
        stroke: $c-pink;
      }
    }
  }

  &.homepage:hover {
    .current-lang {
      color: $c-white;
    }

    .arrow {
      path {
        stroke: $c-white;
      }
    }
  }
}

.current-lang,
h4 {
  // width: 30px;
  display: inline-block;
  letter-spacing: 1.8px;
  transition: all 0.3s ease-in-out;
}

.arrow {
  pointer-events: none;
  width: 17px;
  display: inline-block;
  transform-origin: center;
  transition: all 0.3s ease-in-out;
  margin-bottom: 1px;
  margin-left: 8px;

  path {
    stroke: $c-white;
  }
}

.other-lang {
  position: absolute;
  right: 20px;
  height: 0;
  overflow: hidden;
  width: 40px;
  text-align: center;
  letter-spacing: 1.8px;
  transition: all 0.3s ease-in-out;

  @include breakpoint('sm-and-down') {
    right: 18px;
  }

  h4 {
    width: 30px;

    &:hover {
      color: $c-pink;
    }
  }
}

.cblack {
  h4 {
    color: $c-black;

    &:hover {
      color: $c-white;
    }
  }

  .arrow {
    path {
      stroke: #000;
    }

    &:hover {
      transform: scale(1.3);

      &.flip {
        transform: scale(1.3) rotate(180deg);
      }

      path {
        stroke: $c-white;
      }
    }
  }
}
</style>
